/*
 * js工具类集合
 */
import { getUserInegralMessage } from '@/api/user/integralMal.js';
import config from '@/config';
import vue from '../main';
import { getRealRate } from '@/api/trademarkRegister/reviewOpinions';
import Decimal from 'decimal.js';
import moment from 'moment';
import { openCJTSupportWidget } from '@/utils/cjtSupportWidget';
let getPriceCompute = async (li) => {
  let resNum = 0; //总费用
  const productSpecsDTOList = li.productInfoDTO.productSpecsDTOList || []; //商品服务产品
  const specsObj = productSpecsDTOList.find((v) => v.id === li.trademarkOaPlan.productSpecsId); //所选的服务产品
  const arr = []; //所有产品规格费用项列表
  let rateList = []; //汇率对象列表
  if (specsObj) {
    //取修改后价格
    specsObj.settlementCurrency = 'CNY';
    specsObj.servicePrice = li.trademarkOaPlan.sellingPrice || 0;

    arr.push(specsObj); //所选产品规格（第一项）
    for (const keyStr of specsObj.subSpecsCode || []) {
      const specsObj2 = productSpecsDTOList.find((v) => v.specsCode === keyStr);

      if (specsObj2 && specsObj2.officialFlag) {
        //找出是官费的
        arr.push(specsObj2);
      }
    }
  }
  const settlementCurrencyArr = arr.map((v) => v.settlementCurrency).filter((v) => v !== 'CNY'); //汇率
  if (settlementCurrencyArr.length > 0) {
    const resObj = await getRealRate({
      type: 'IN',
      currencyList: settlementCurrencyArr,
    });
    rateList = resObj.data || [];
  }
  for (const li of arr) {
    let price = 0;
    if (li.settlementCurrency === 'CNY') {
      price = li.servicePrice || 0;
    } else {
      const obj = rateList.find((v) => v.beforeCurrency === li.settlementCurrency);
      if (obj && obj.afterAmount) {
        price = new Decimal(li.costPrice).mul(new Decimal(obj.afterAmount)).toNumber();
      }
    }
    price = price > 0 ? Math.round(price) || 1 : 0;
    resNum = new Decimal(resNum).add(new Decimal(price)).toNumber();
  }
  // this.priceObj[li.trademarkOaPlans.oaPlanId] = resNum;
  return resNum;
};
export default {
  /** 不四舍五入 保留两位小数
   * @param {*}   列如132.45646456,2 返回132.45
   */
  formatDecimal(num, decimal) {
    num = num.toString();
    let index = num.indexOf('.');
    if (index !== -1) {
      num = num.substring(0, decimal + index + 1);
    } else {
      num = num.substring(0);
    }
    return parseFloat(num).toFixed(decimal);
  },

  /**
   * 防止精度丢失
   * @param {*}  arg1 数值 arg2 100 列如：0.009,100 返回0.9
   */
  floatMultiply(arg1, arg2) {
    var m = 0,
      s1 = arg1.toString(),
      s2 = arg2.toString();
    try {
      m += s1.split('.')[1].length;
    } catch (e) {}
    try {
      m += s2.split('.')[1].length;
    } catch (e) {}
    return (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) / Math.pow(10, m);
  },

  // 金额求和（相加/相减）
  countSum(arr) {
    if (!arr.length) return 0;
    arr = arr.map((v) => {
      if (v && !Number.isNaN(Number(v))) return Math.round(v * 100);
      return 0;
    });
    const result = arr.reduce((prev, curr) => {
      return prev + curr;
    }, 0);
    return result / 100;
  },

  // 用户积分反馈
  getUserInegralMessage(that, type = '') {
    // getUserInegralMessage().then((res) => {
    //   if (+res.code === 0 && res.data.length) {
    //     const cur = res.data[res.data.length - 1];
    //     that.$Message.success({
    //       content: `${cur.action}，获得${cur.integral}积分`,
    //       duration: 5,
    //     });
    //   }
    // });
  },

  // 相减
  accSub(arg1, arg2) {
    var r1, r2, m, n;
    try {
      r1 = arg1.toString().split('.')[1].length;
    } catch (e) {
      r1 = 0;
    }
    try {
      r2 = arg2.toString().split('.')[1].length;
    } catch (e) {
      r2 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2));
    n = r1 >= r2 ? r1 : r2;
    return ((arg1 * m - arg2 * m) / m).toFixed(n);
  },
  // 四舍五入，有小数则保留两位，五小数则为整数
  toDecimalRound(num) {
    if (isNaN(num) || (!num && num !== 0)) {
      return 0;
    }
    return Math.round(num * 100) / 100;
  },

  /**
   * 下载文件到本地
   * @param {*} url
   */
  downloadFile(url, name) {
    let newUrl = url.replace('http://', 'https://');
    let timestamp = new Date().getTime();
    var a = document.createElement('a');
    let fileName = newUrl.split('.').pop().toLowerCase();
    a.download = (name || timestamp) + '.' + fileName;
    a.href = newUrl;
    a.target = newUrl;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  },

  /**
   * 后端返回文件流下载
   * @param {*} content
   */
  downFile(url, fileName, suffix = 'zip') {
    const fileReader = new FileReader();
    let xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.setRequestHeader('token', localStorage.getItem('token'));
    xhr.setRequestHeader('sessionId', localStorage.getItem('sessionId'));
    xhr.setRequestHeader('enterprisecode', 'ksy');
    xhr.responseType = 'blob';
    xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
    xhr.send();
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
        const content = xhr.response;
        fileReader.onloadend = () => {
          try {
            const jsonData = JSON.parse(fileReader.result); // 说明是普通对象数据，后台转换失败
            Message.error(jsonData.message || '当前模板未配置，请联系管理员');
          } catch (err) {
            let fileSuffix = xhr.getResponseHeader('fileSuffix') || suffix; //获取文件格式
            let timestamp = new Date().getTime();
            let name = fileName || timestamp;
            let elink = document.createElement('a');
            let blob = new Blob([content]);
            elink.style.display = 'none';
            elink.href = URL.createObjectURL(blob);
            elink.download = name + '.' + fileSuffix;
            document.body.appendChild(elink);
            elink.click();
            document.body.removeChild(elink);
          }
        };
        fileReader.readAsText(new Blob([content]));
      }
    };
  },
  /**
   * 后端返回文件流下载
   * @param {*} content
   */
  downFilePost(url, fileName, formData, suffix = 'zip') {
    const fileReader = new FileReader();
    let xhr = new XMLHttpRequest();
    xhr.open('POST', url, true);
    xhr.setRequestHeader('token', localStorage.getItem('token'));
    xhr.setRequestHeader('sessionId', localStorage.getItem('sessionId'));
    xhr.setRequestHeader('enterprisecode', 'kby');
    xhr.responseType = 'blob';
    xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
    xhr.send(JSON.stringify(formData));
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
        const content = xhr.response;
        fileReader.onloadend = () => {
          try {
            const jsonData = JSON.parse(fileReader.result); // 说明是普通对象数据，后台转换失败
            Message.error(jsonData.message || '当前模板未配置，请联系管理员');
          } catch (err) {
            let fileSuffix = xhr.getResponseHeader('fileSuffix') || suffix; //获取文件格式
            let timestamp = new Date().getTime();
            let name = fileName || timestamp;
            let elink = document.createElement('a');
            let blob = new Blob([content]);
            elink.style.display = 'none';
            elink.href = URL.createObjectURL(blob);
            elink.download = name + '.' + fileSuffix;
            document.body.appendChild(elink);
            elink.click();
            document.body.removeChild(elink);
          }
        };
        fileReader.readAsText(new Blob([content]));
      }
    };
  },
  // 图片转换
  convertImage(data) {
    try {
      data = JSON.parse(data);
    } catch (error) {
      try {
        if (typeof data === 'string') {
          data = data.split(',').filter((i) => i);
        }
      } catch (e) {}
    }
    let result = data.map((item) => item.replace('http://', 'https://'));
    return result;
  },
  //获取iframeUrl 地址
  getIframeUrl(url, p1) {
    let resUrl = config.apiUrl.baseIframeUrl + url + '?type=kby';
    // let resUrl = 'http://localhost:8888' + url + '?type=kby';
    const p2 = {
      token: encodeURIComponent(localStorage.getItem('token')),
      Sessionid: localStorage.getItem('sessionId'),
      Enterpriseid: '3', //创知汇
      Enterprisecode: 'pn4pn456jy1', //创知汇code
      Clientcode: 'CZH',
    };
    const params = Object.assign({}, p2, p1);
    for (const key in params) {
      resUrl += '&' + key + '=' + params[key];
    }
    return resUrl;
  },
  /**
   * 判断是否是图片
   * @param {string} src
   * @returns Boolean
   */
  isImage(src) {
    let imgSuffix = ['jpg', 'jpeg', 'png', 'gif', 'svg', 'bmp', 'tif'];
    return imgSuffix.includes(src.substr(src.lastIndexOf('.') + 1).toLowerCase());
  },
  // 获取 iframeUrl 请求头信息
  getHeaders() {
    let resObj = {};
    const type = vue.$route.query.type;
    if (type === 'admin') {
      resObj = {
        Authorization: 'Bearer ' + vue.$route.query.token,
        Enterpriseid: vue.$route.query.Enterpriseid,
        type,
      };
    } else {
      resObj = {
        type,
      };
    }
    return resObj;
  },

  //支付审查意见费用
  async reviewOpinionsGoPay(li) {
    let selectedPlan = '';
    let trademarkOaPlanVOS = li.trademarkOaPlanVOS;
    for (const plan of trademarkOaPlanVOS) {
      if (!plan.trademarkOaPlan && plan.trademarkOaPlans) {
        plan.trademarkOaPlan = plan.trademarkOaPlans;
      }
    }
    if (trademarkOaPlanVOS && trademarkOaPlanVOS.length)
      selectedPlan = trademarkOaPlanVOS.filter((item) => {
        return item.trademarkOaPlan.planStatus === 'SELECTED';
      });
    if (selectedPlan && selectedPlan.length) {
      let newProductInfoHD = selectedPlan[0].productInfoDTO;
      let trademarkOaPlan = selectedPlan[0].trademarkOaPlan;
      // 计算金额
      let res = await getPriceCompute(selectedPlan[0]);
      newProductInfoHD.productSpecsDTOList = newProductInfoHD.productSpecsDTOList.filter((item) => {
        return item.id === trademarkOaPlan.productSpecsId;
      });
      newProductInfoHD.servicePriceSum = Math.round(res);
      newProductInfoHD.quantity = 1;
      newProductInfoHD.currency = '￥';
      newProductInfoHD.productInfoAttributeRelationDTOList = [];
      newProductInfoHD.serviceId = li.serviceId || li.trademarkOaWorkOrders[0].serviceId;
      newProductInfoHD.serviceType = 'OA';
      localStorage.setItem('selectedList', JSON.stringify(newProductInfoHD));
      window.open(location.origin + '/client/sureOrder?from=buyNow', '_blank');
    }
  },

  getPromteCodeV2() {
    let promteCode = '';
    try {
      const promteCodeV2 = JSON.parse(localStorage.getItem('promteCodeV2'));
      if (moment().isBefore(moment(promteCodeV2.expireTime))) {
        promteCode = promteCodeV2.promteCode || '';
      }
    } catch (error) {
      console.log('error', error);
    }
    return promteCode;
  },

  formatPriceString(price, fraction = 2) {
    const [interger, decimal = ''] = Decimal(price).toDecimalPlaces(2).toLocaleString().split('.');
    return `${interger}.${decimal.padEnd(fraction, '0')}`;
  },

  exportFile(content, fileName, suffix = 'zip') {
    const fileReader = new FileReader();
    fileReader.onloadend = () => {
      try {
        const jsonData = JSON.parse(fileReader.result);
        Message.error(jsonData.message || '下载失败！');
      } catch (err) {
        let timestamp = new Date().getTime();
        let elink = document.createElement('a');
        let blob = new Blob([content]);
        let name = fileName || timestamp;
        elink.download = name + '.' + suffix;
        elink.style.display = 'none';
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        document.body.removeChild(elink);
      }
    };
    fileReader.readAsText(new Blob([content]));
  },

  openChat: () => openCJTSupportWidget(),
};



// WEBPACK FOOTER //
// ./src/utils/util.js